// extracted by mini-css-extract-plugin
export var chatHtmlText = "_rx-2";
export var chatLink = "_rx-0";
export var chatText = "_rx-1";